export default "__VITE_ASSET__CLgaTT8w__"